import {
  Field,
  RangePicker,
  Filter,
  Text,
  TimePicker,
  Select
} from "components/commons";
import React, { useCallback, useMemo } from "react";
import lang from "translations";
import { modifyFromTimeRange, modifyToTimeRange } from "services";

const RefundClaimReportFilter = ({
  filterState,
  modifyFilter,
  clearFilter,
  onClear,
  onApply,
}) => {

  const statusOptions = useMemo(
    () => [
      { value: "REFUNDED", text: lang.completed },
      { value: "", text: lang.all },
    ],
    []
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await onApply(searchKey);
    },
    [onApply]
  );

  const clearFilterCb = useCallback(() => {
    const { filterState, requestState } = clearFilter();
    onClear(filterState, requestState);
  }, [clearFilter, onClear]);

  const changeDateRangeCb = useCallback(
    (name, value) => {
      modifyFilter(name, { value });
    },
    [modifyFilter]
  );

  return (
    <div>
      <Filter
        onClear={clearFilterCb}
        onApply={applyFilterCb}
        dateRange={filterState.dateRange}
        searchBox={true}
        actionsSpan={3}
        placeholder={lang.searchByGuestNameEmailTagUid}
      >
        <Field filterLabel={lang.dateRange} className="col-span-3">
          <RangePicker
            name="dateRange"
            onChange={changeDateRangeCb}
            value={filterState.dateRange}
          />
        </Field>
        <Field filterLabel={lang.timeRange} className="col-span-3">
          <div className="flex items-center">
            <TimePicker
              value={filterState.dateRange[0]}
              onChange={(val) => {
                modifyFromTimeRange(val, filterState, modifyFilter);
              }}
            />
            <Text className="mx-sm" color="text-black-light">
              to
            </Text>
            <TimePicker
              value={filterState.dateRange[1]}
              onChange={(val) => {
                modifyToTimeRange(val, filterState, modifyFilter);
              }}
            />
          </div>
        </Field>
        <Field className="col-span-3" filterLabel={lang.status}>
          <Select
            name="status"
            options={statusOptions}
            value={filterState.status}
            onChange={(name, obj) => {
              modifyFilter(name, { value: obj.value });
            }}
            sortOptions={false}
          />
        </Field>
      </Filter>
    </div>
  );
};

export default RefundClaimReportFilter;
